module.exports = __webpack_public_path__ + "static/work_minoriti_loop-21dbe89baa0e64e4e45bd427a6a383c7.mp4";